// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__36QTN","ranges":"BmiRanges_ranges__A6z11"};